const autoimg = {
    inserted(el, { value }) {
        function get() {
            let v = value,
                w = parseInt(el.style.width);
            el.style.height = (w / v[0] * v[1]) + 'px'
            el.style.width = w + 'px'

            // style.height = style.width / v[0] * v[1]
        }
        el._vueReize_ = setInterval(get, 500);
    },
    //只调用一次，指令与元素解绑时调用。
    unbind(el) {
        clearInterval(el._vueReize_)
    }
}

export default autoimg